import { createContext, useContext, useState, useEffect } from "react";
import API_URL from "../config";

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("c3adminid");
    const storedToken = localStorage.getItem("c3tokenid");
    const storedUserType = localStorage.getItem("c3userType");

    if (storedToken && storedUser && storedUserType) {
      fetchUser(storedUser, storedUserType);
    }
  }, []);

  const login = (user, token, userType) => {
    setAdmin(user);
    localStorage.setItem("c3adminid", user._id);
    localStorage.setItem("c3tokenid", token);
    localStorage.setItem("c3userType", userType);
  };

  const logout = () => {
    setAdmin(null);
    localStorage.removeItem("c3adminid");
    localStorage.removeItem("c3tokenid");
    localStorage.removeItem("c3userType");
  };

  const fetchUser = async (userId, userType) => {
    try {
      const endpoint =
        userType === "Admin"
          ? `${API_URL}/admin/${userId}`
          : `${API_URL}/trainer/${userId}`;

      const response = await fetch(endpoint, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Invalid token or failed to fetch user");
      }

      const userData = await response.json();
      setAdmin(userData);
    } catch (error) {
      console.error("Error fetching user:", error);
      logout();
    }
  };

  return (
    <AdminContext.Provider value={{ admin, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  return useContext(AdminContext);
};
